import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-root',
    template: ``,
    styles: [],
    standalone: false
})
export class DmbridgeAuthorizeComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }
}
